// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ---------------- Sidebar ---------------- */
.sidebar {
  width: 230px;
  background-color: #0C111D;
  color: white;
  height: 100vh;
  padding: 1rem 0;
  position: fixed;
  top: 0;
  left: 0;
  overflow-y: auto;
  box-shadow: 2px 0 6px rgba(0, 0, 0, 0.2);
  font-size: 12px;
  padding-top: 0;
  transition: width 0.3s, background 0.3s;
  overflow-y: auto;
  -ms-overflow-style: none;
  scrollbar-width: none;
}

.sidebar::-webkit-scrollbar {
  display: none;
}

.sidebar.collapsed {
  width: 60px;
}


.sidebar-header {
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 10px;
  margin-bottom: 1rem;
}

.sidebar-logo-img {
  width: 60px;
  height: 60px;
  border-radius: 50%;
  object-fit: cover;
  margin-bottom: 8px;
}

.sidebar-logo-text {
  font-size: 1rem;
  color: white;
  text-align: center;
  display: block;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.sidebar-collapsed-text {
  font-size: 1.2rem;
  font-weight: bold;
  color: white;
  border-radius: 8px;
}

/* ---------------- Collapse Button ---------------- */ 
.collapse-btn {
  background: none;
  border: none;
  color: #007bff;
  cursor: pointer;
  font-size: 1rem;
}

/* ---------------- Menu Items ---------------- */
.menu-item {
  margin-bottom: 0.5rem;
}



.menu-item a,
.menu-parent {
  display: flex;
  align-items: center;
  padding: 0.6rem 1rem;
  text-decoration: none;
  color: white;
  border-radius: 20px;
  font-size: 13px;
  cursor: pointer;
  transition: all 0.3s;
  padding: 0.9rem 1.5rem; /* increased padding for more spacing */
  gap: 0.75rem;
}

.icon {
  margin-right: 1rem;
  font-size: 1rem;
  display: flex;
  align-items: center;
  justify-content: center;
}

.arrow {
  margin-left: auto;
  font-size: 0.75rem;
}

/* ---------------- Submenu ---------------- */
.submenu {
  display: flex;
  flex-direction: column;
  margin-left: 1.4rem;
  margin-top: 0.2rem;
  padding: 5px 0;
}

.submenu a {
  padding: 6px 12px;
  border-radius: 4px;
  color: #d1d5db;
  font-size: 12.5px;
  display: flex;
  align-items: center;
  transition: all 0.3s ease;
  text-decoration: none;
}

.submenu a:hover {
  background: rgba(0, 123, 255, 0.1);
  color: white;
  transform: translateX(2px);
}

.active-submenu {
  background: rgba(0, 123, 255, 0.15);
  font-weight: bold;
}

/* ---------------- Active States ---------------- */
.sidebar .active {
  background-color: #facc15;
  color: #1e293b;
}

/* ---------------- Menu Groups ---------------- */
.menu-group {
  display: flex;
  flex-direction: column;
  margin: 2px 0;
  border-left: 2px solid transparent;
  border-right: 2px solid transparent;
  transition: all 0.3s ease;
  border-radius: 4px;
}

.menu-active-group {
  /* border-left: 2px solid hsl(43 74% 53%) !important;
  border-right: 2px solid hsl(43 74% 53%) !important; */
  background: rgba(0, 123, 255, 0.05);
}

/* ---------------- Layout ---------------- */
.layout-main {
  margin-left: 248px;
  transition: margin-left 0.3s;
}

.layout-main.collapsed {
  margin-left: 60px;
}

.layout-content {
  flex: 1 1;
  overflow-y: auto;
  padding: 0.8rem 0;
}

.sidebar-header {
  display: flex;
  align-items: center;
  padding: 12px;
  background-color: #0C111D;
  border-bottom: 1px solid #384366;
  color: #fff;
  transition: background 0.3s;
  margin-top: 0;
}

.menu-text {
  color: #98a7b6;
  font-weight: 600;
}

.menu-parent:hover .menu-text,
.menu-parent:hover .icon {
  color: #ffffff !important;
}

.submenu a:hover {
  color: #ffffff !important;
}

.submenu a {
  color: #cfcfcf;
  text-decoration: none;
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 6px 12px;
  border-radius: 4px;
  transition: all 0.2s ease-in-out;
}

.submenu a:hover {
  background-color: rgba(255, 255, 255, 0.05);
}


.menu-parent,
.submenu a {
  color: #cfcfcf;
  transition: all 0.2s ease-in-out;
}

.menu-parent:hover,
.submenu a:hover {
  color: #ffffff;
  background-color: rgba(255, 255, 255, 0.05);
  cursor: pointer;
}

.menu-parent:hover{
  background-color: hsl(0 0% 75%);
  color: hsl(222 47% 6%);
}

.menu-parent:hover .icon,.menu-parent:hover .menu-text{
  color: hsl(222 47% 6%) !important;
}

.menu-parent-open,
.active-submenu {
  color: #ffffff;
  font-weight: 600;
  background-color: rgba(255, 255, 255, 0.08);
  border-radius: 20px;
}

.menu-parent-open .menu-text,
.menu-parent-open .icon {
  color: hsl(43 74% 53%) !important;
  font-weight: 600;
}

.active-submenu {
  color: #ffffff !important;
  font-weight: 600;
  background-color: rgba(255, 255, 255, 0.08);
  border-radius: 4px;
}


.menu-parent-open
{
  border: 2px solid hsl(43 74% 53%) !important;
outline: 1px solid hsl(222 47% 6%);
}

/* ---------------- Submenu ---------------- */
.submenu {
  display: flex;
  flex-direction: column;
  margin-left: 1.4rem; /* indent for submenu */
  margin-top: 0.5rem; /* spacing above submenu */
  padding: 5px 0;
  gap: 4px; /* vertical gap between submenu items */
}

.submenu a {
  padding: 8px 14px; /* thoda zyada padding for airy look */
  border-radius: 6px; /* rounded edges */
  color: #cfcfcf;
  font-size: 13px; /* slightly larger for readability */
  display: flex;
  align-items: center;
  gap: 10px; /* spacing between icon and text */
  transition: all 0.2s ease-in-out;
  text-decoration: none;
}

.submenu a:hover {
  background-color: rgba(255, 255, 255, 0.08);
  color: #ffffff;
  transform: translateX(2px);
}

.active-submenu {
  color: #ffffff !important;
  font-weight: 600;
  background-color: rgba(255, 255, 255, 0.1);
  border-radius: 6px;
}
`, "",{"version":3,"sources":["webpack://./src/components/Sidebar/Sidebar.css"],"names":[],"mappings":"AAAA,8CAA8C;AAC9C;EACE,YAAY;EACZ,yBAAyB;EACzB,YAAY;EACZ,aAAa;EACb,eAAe;EACf,eAAe;EACf,MAAM;EACN,OAAO;EACP,gBAAgB;EAChB,wCAAwC;EACxC,eAAe;EACf,cAAc;EACd,uCAAuC;EACvC,gBAAgB;EAChB,wBAAwB;EACxB,qBAAqB;AACvB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,WAAW;AACb;;;AAGA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,YAAY;EACZ,kBAAkB;EAClB,cAAc;EACd,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,iBAAiB;EACjB,iBAAiB;EACjB,YAAY;EACZ,kBAAkB;AACpB;;AAEA,sDAAsD;AACtD;EACE,gBAAgB;EAChB,YAAY;EACZ,cAAc;EACd,eAAe;EACf,eAAe;AACjB;;AAEA,iDAAiD;AACjD;EACE,qBAAqB;AACvB;;;;AAIA;;EAEE,aAAa;EACb,mBAAmB;EACnB,oBAAoB;EACpB,qBAAqB;EACrB,YAAY;EACZ,mBAAmB;EACnB,eAAe;EACf,eAAe;EACf,oBAAoB;EACpB,sBAAsB,EAAE,uCAAuC;EAC/D,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA,8CAA8C;AAC9C;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;EAClB,cAAc;EACd,iBAAiB;EACjB,aAAa;EACb,mBAAmB;EACnB,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,kCAAkC;EAClC,YAAY;EACZ,0BAA0B;AAC5B;;AAEA;EACE,mCAAmC;EACnC,iBAAiB;AACnB;;AAEA,oDAAoD;AACpD;EACE,yBAAyB;EACzB,cAAc;AAChB;;AAEA,kDAAkD;AAClD;EACE,aAAa;EACb,sBAAsB;EACtB,aAAa;EACb,kCAAkC;EAClC,mCAAmC;EACnC,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE;uDACqD;EACrD,mCAAmC;AACrC;;AAEA,6CAA6C;AAC7C;EACE,kBAAkB;EAClB,4BAA4B;AAC9B;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,SAAO;EACP,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,aAAa;EACb,yBAAyB;EACzB,gCAAgC;EAChC,WAAW;EACX,2BAA2B;EAC3B,aAAa;AACf;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;;EAEE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,cAAc;EACd,qBAAqB;EACrB,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,kBAAkB;EAClB,gCAAgC;AAClC;;AAEA;EACE,2CAA2C;AAC7C;;;AAGA;;EAEE,cAAc;EACd,gCAAgC;AAClC;;AAEA;;EAEE,cAAc;EACd,2CAA2C;EAC3C,eAAe;AACjB;;AAEA;EACE,+BAA+B;EAC/B,sBAAsB;AACxB;;AAEA;EACE,iCAAiC;AACnC;;AAEA;;EAEE,cAAc;EACd,gBAAgB;EAChB,2CAA2C;EAC3C,mBAAmB;AACrB;;AAEA;;EAEE,iCAAiC;EACjC,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;EACzB,gBAAgB;EAChB,2CAA2C;EAC3C,kBAAkB;AACpB;;;AAGA;;EAEE,4CAA4C;AAC9C,kCAAkC;AAClC;;AAEA,8CAA8C;AAC9C;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB,EAAE,uBAAuB;EAC5C,kBAAkB,EAAE,0BAA0B;EAC9C,cAAc;EACd,QAAQ,EAAE,uCAAuC;AACnD;;AAEA;EACE,iBAAiB,EAAE,sCAAsC;EACzD,kBAAkB,EAAE,kBAAkB;EACtC,cAAc;EACd,eAAe,EAAE,oCAAoC;EACrD,aAAa;EACb,mBAAmB;EACnB,SAAS,EAAE,kCAAkC;EAC7C,gCAAgC;EAChC,qBAAqB;AACvB;;AAEA;EACE,2CAA2C;EAC3C,cAAc;EACd,0BAA0B;AAC5B;;AAEA;EACE,yBAAyB;EACzB,gBAAgB;EAChB,0CAA0C;EAC1C,kBAAkB;AACpB","sourcesContent":["/* ---------------- Sidebar ---------------- */\n.sidebar {\n  width: 230px;\n  background-color: #0C111D;\n  color: white;\n  height: 100vh;\n  padding: 1rem 0;\n  position: fixed;\n  top: 0;\n  left: 0;\n  overflow-y: auto;\n  box-shadow: 2px 0 6px rgba(0, 0, 0, 0.2);\n  font-size: 12px;\n  padding-top: 0;\n  transition: width 0.3s, background 0.3s;\n  overflow-y: auto;\n  -ms-overflow-style: none;\n  scrollbar-width: none;\n}\n\n.sidebar::-webkit-scrollbar {\n  display: none;\n}\n\n.sidebar.collapsed {\n  width: 60px;\n}\n\n\n.sidebar-header {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  padding: 10px;\n  margin-bottom: 1rem;\n}\n\n.sidebar-logo-img {\n  width: 60px;\n  height: 60px;\n  border-radius: 50%;\n  object-fit: cover;\n  margin-bottom: 8px;\n}\n\n.sidebar-logo-text {\n  font-size: 1rem;\n  color: white;\n  text-align: center;\n  display: block;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n.sidebar-collapsed-text {\n  font-size: 1.2rem;\n  font-weight: bold;\n  color: white;\n  border-radius: 8px;\n}\n\n/* ---------------- Collapse Button ---------------- */ \n.collapse-btn {\n  background: none;\n  border: none;\n  color: #007bff;\n  cursor: pointer;\n  font-size: 1rem;\n}\n\n/* ---------------- Menu Items ---------------- */\n.menu-item {\n  margin-bottom: 0.5rem;\n}\n\n\n\n.menu-item a,\n.menu-parent {\n  display: flex;\n  align-items: center;\n  padding: 0.6rem 1rem;\n  text-decoration: none;\n  color: white;\n  border-radius: 20px;\n  font-size: 13px;\n  cursor: pointer;\n  transition: all 0.3s;\n  padding: 0.9rem 1.5rem; /* increased padding for more spacing */\n  gap: 0.75rem;\n}\n\n.icon {\n  margin-right: 1rem;\n  font-size: 1rem;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.arrow {\n  margin-left: auto;\n  font-size: 0.75rem;\n}\n\n/* ---------------- Submenu ---------------- */\n.submenu {\n  display: flex;\n  flex-direction: column;\n  margin-left: 1.4rem;\n  margin-top: 0.2rem;\n  padding: 5px 0;\n}\n\n.submenu a {\n  padding: 6px 12px;\n  border-radius: 4px;\n  color: #d1d5db;\n  font-size: 12.5px;\n  display: flex;\n  align-items: center;\n  transition: all 0.3s ease;\n  text-decoration: none;\n}\n\n.submenu a:hover {\n  background: rgba(0, 123, 255, 0.1);\n  color: white;\n  transform: translateX(2px);\n}\n\n.active-submenu {\n  background: rgba(0, 123, 255, 0.15);\n  font-weight: bold;\n}\n\n/* ---------------- Active States ---------------- */\n.sidebar .active {\n  background-color: #facc15;\n  color: #1e293b;\n}\n\n/* ---------------- Menu Groups ---------------- */\n.menu-group {\n  display: flex;\n  flex-direction: column;\n  margin: 2px 0;\n  border-left: 2px solid transparent;\n  border-right: 2px solid transparent;\n  transition: all 0.3s ease;\n  border-radius: 4px;\n}\n\n.menu-active-group {\n  /* border-left: 2px solid hsl(43 74% 53%) !important;\n  border-right: 2px solid hsl(43 74% 53%) !important; */\n  background: rgba(0, 123, 255, 0.05);\n}\n\n/* ---------------- Layout ---------------- */\n.layout-main {\n  margin-left: 248px;\n  transition: margin-left 0.3s;\n}\n\n.layout-main.collapsed {\n  margin-left: 60px;\n}\n\n.layout-content {\n  flex: 1;\n  overflow-y: auto;\n  padding: 0.8rem 0;\n}\n\n.sidebar-header {\n  display: flex;\n  align-items: center;\n  padding: 12px;\n  background-color: #0C111D;\n  border-bottom: 1px solid #384366;\n  color: #fff;\n  transition: background 0.3s;\n  margin-top: 0;\n}\n\n.menu-text {\n  color: #98a7b6;\n  font-weight: 600;\n}\n\n.menu-parent:hover .menu-text,\n.menu-parent:hover .icon {\n  color: #ffffff !important;\n}\n\n.submenu a:hover {\n  color: #ffffff !important;\n}\n\n.submenu a {\n  color: #cfcfcf;\n  text-decoration: none;\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  padding: 6px 12px;\n  border-radius: 4px;\n  transition: all 0.2s ease-in-out;\n}\n\n.submenu a:hover {\n  background-color: rgba(255, 255, 255, 0.05);\n}\n\n\n.menu-parent,\n.submenu a {\n  color: #cfcfcf;\n  transition: all 0.2s ease-in-out;\n}\n\n.menu-parent:hover,\n.submenu a:hover {\n  color: #ffffff;\n  background-color: rgba(255, 255, 255, 0.05);\n  cursor: pointer;\n}\n\n.menu-parent:hover{\n  background-color: hsl(0 0% 75%);\n  color: hsl(222 47% 6%);\n}\n\n.menu-parent:hover .icon,.menu-parent:hover .menu-text{\n  color: hsl(222 47% 6%) !important;\n}\n\n.menu-parent-open,\n.active-submenu {\n  color: #ffffff;\n  font-weight: 600;\n  background-color: rgba(255, 255, 255, 0.08);\n  border-radius: 20px;\n}\n\n.menu-parent-open .menu-text,\n.menu-parent-open .icon {\n  color: hsl(43 74% 53%) !important;\n  font-weight: 600;\n}\n\n.active-submenu {\n  color: #ffffff !important;\n  font-weight: 600;\n  background-color: rgba(255, 255, 255, 0.08);\n  border-radius: 4px;\n}\n\n\n.menu-parent-open\n{\n  border: 2px solid hsl(43 74% 53%) !important;\noutline: 1px solid hsl(222 47% 6%);\n}\n\n/* ---------------- Submenu ---------------- */\n.submenu {\n  display: flex;\n  flex-direction: column;\n  margin-left: 1.4rem; /* indent for submenu */\n  margin-top: 0.5rem; /* spacing above submenu */\n  padding: 5px 0;\n  gap: 4px; /* vertical gap between submenu items */\n}\n\n.submenu a {\n  padding: 8px 14px; /* thoda zyada padding for airy look */\n  border-radius: 6px; /* rounded edges */\n  color: #cfcfcf;\n  font-size: 13px; /* slightly larger for readability */\n  display: flex;\n  align-items: center;\n  gap: 10px; /* spacing between icon and text */\n  transition: all 0.2s ease-in-out;\n  text-decoration: none;\n}\n\n.submenu a:hover {\n  background-color: rgba(255, 255, 255, 0.08);\n  color: #ffffff;\n  transform: translateX(2px);\n}\n\n.active-submenu {\n  color: #ffffff !important;\n  font-weight: 600;\n  background-color: rgba(255, 255, 255, 0.1);\n  border-radius: 6px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
